import type { RoleDto } from "common/models/api/models/RoleDto";
import RoleSelect from "ui/role/components/input/RoleSelect/RoleSelect";
import { RoleSelectProps } from "ui/role/components/input/RoleSelect/RoleSelect.types";
import { getRoleMapKey } from "ui/role/utils/roleMap";
import useRoleSelectOptions from "./hooks/useRoleSelectOptions";

export type UserRoleSelectProps = Omit<RoleSelectProps, "options" | "onRoleSelected" | "roleKey"> & {
    onRoleSelected: (role: RoleDto) => void;
    role: RoleDto | undefined;
};

const UserRoleSelect = ({ onRoleSelected, role, ...props }: UserRoleSelectProps) => {
    const { options, roleMap } = useRoleSelectOptions();

    function handleRoleChange(roleKey: string) {
        const selectedRole = roleMap[roleKey];

        if (selectedRole) {
            onRoleSelected(selectedRole);
        }
    }

    const roleKey = role ? getRoleMapKey(role) : undefined;

    return <RoleSelect options={options} {...props} roleKey={roleKey} onRoleSelected={handleRoleChange} />;
};

export default UserRoleSelect;
